'use client';

var X_LABEL_HEIGHT = 20;
var CHART_START_DRAWING = 20;
/*
 * Chart config
 * */
var CHART_DECREASE_RATIO = 0.02;
var SPECIFIC_CHART = ['line'];
/* Line */
var CHART_LINE_WIDTH = 3;
/*
 * Color config
 * */
var LIST_COLORS = [
    { foreground: '#001744', background: '#ccd0d9' },
    { foreground: '#6FB920', background: '#e2f1d2' },
    { foreground: '#FF7D55', background: '#ffe5dd' },
    { foreground: '#005AFF', background: '#ccdeff' },
    { foreground: '#f7bf06', background: '#fdf2cd' },
    { foreground: '#48BBFF', background: '#daf1ff' }
];
var HOVER_COLOR = '#f7faff';
/*
 * Text style
 * */
var TEST_TEXT = 'VNW_WITH_LOVE';
var LINE_HEIGHT = 2;
var TEXT_COLOR = '#848484';
/* Axes cross line style */
var CROSS_LINE_COLOR = '#dddddd';
var CROSS_LINE_WIDTH = 1;
/*
 * Default font
 * */
var defaultFont = {
    color: TEXT_COLOR,
    family: 'Inter',
    size: 12,
    weight: 500
};
var defaultTooltip = {
    title: {
        color: '#999',
        size: 14,
        weight: 700
    },
    content: {
        color: '#999',
        size: 13,
        weight: 500
    },
    padding: 10,
    borderRadius: 8,
    boxShadow: {
        offsetX: 0,
        offsetY: 2,
        blur: 8,
        color: 'rgba(51, 51, 51, 0.15)'
    },
    backgroundColor: '#fff'
};

export { CHART_DECREASE_RATIO, CHART_LINE_WIDTH, CHART_START_DRAWING, CROSS_LINE_COLOR, CROSS_LINE_WIDTH, HOVER_COLOR, LINE_HEIGHT, LIST_COLORS, SPECIFIC_CHART, TEST_TEXT, TEXT_COLOR, X_LABEL_HEIGHT, defaultFont, defaultTooltip };
//# sourceMappingURL=config.js.map
